type SelectedOption = { value: string; label: string };

export function isSameOptionSelection(
  left: SelectedOption | SelectedOption[] | null,
  right: SelectedOption | SelectedOption[] | null,
): boolean {
  if (Array.isArray(left) && Array.isArray(right)) {
    return (
      left.length === right.length &&
      left.every((option, index) => isSameOptionSelection(option, right[index] ?? null))
    );
  }
  if (Array.isArray(left) || Array.isArray(right)) return false;
  if (left === null || right === null) return left === right;
  return left.value === right.value && left.label === right.label;
}
